import { render, staticRenderFns } from "./physioAsset.vue?vue&type=template&id=51047e58&scoped=true"
import script from "./physioAsset.vue?vue&type=script&lang=js"
export * from "./physioAsset.vue?vue&type=script&lang=js"
import style0 from "./physioAsset.vue?vue&type=style&index=0&id=51047e58&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51047e58",
  null
  
)

export default component.exports